module.exports = __webpack_public_path__ + "img/w24-b1.6e1c7ec0.jpg";